import { ROUTES } from 'module/navigation/enums/routes.enums';
import PreloadComp from 'module/preload/PreloadComp';
import { useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import HeaderBar from '../HeaderBar/HeaderBar';
import MabelSidebar from '../MabelSideBar/MabelSidebar';
import { DocumentProvider } from 'module/documents/context';
import { useWorkplaceUser } from 'module/documents/utils';
import Manager from '../../../module/schedule/Manager';
import EmployeeOnboardingProgress from '../../../module/onboarding/page/EmployeeOnboardingProgress';

/**
 * Root application layout component.
 *
 * Handles two rendering paths:
 * - **Onboarding in progress**: Renders only the {@link EmployeeOnboardingProgress} flow
 *   when `user.isOnboardingInProgress` is `true`, hiding all navigation.
 * - **Standard layout**: Renders the full shell with {@link HeaderBar}, {@link MabelSidebar},
 *   and the main content area with all route definitions.
 *
 * Shows `null` while the current user data is loading to avoid a flash of incorrect layout.
 */
export default function Layout(): JSX.Element {
	const [hoveredLayout, setHoveredLayout] = useState(false);
	const { data: user, isLoading } = useWorkplaceUser();
	const [newEmployee, setNewEmployee] = useState({
		firstName: '',
		middleName: '',
		lastName: '',
		email: '',
	});
	
	if (isLoading) {
		return null;
	}

	// Check if user is in onboarding progress
	const isOnboardingInProgress = user?.isOnboardingInProgress === true;

	// If user is in onboarding, show only the onboarding flow
	if (isOnboardingInProgress) {
		return (
			<PreloadComp>
				<EmployeeOnboardingProgress />
			</PreloadComp>
		);
	}

	const renderLayout = (
		<div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
			<DocumentProvider
				defaultUser={user}
				newEmployeeState={[newEmployee, setNewEmployee]}
			>
				<MabelSidebar hoveredLayout={hoveredLayout} setHoveredLayout={setHoveredLayout} />
				<div style={{ flex: 1, minWidth: 0 }}>
					<HeaderBar />
					<main style={{ margin: '0 24px 48px 24px', overflow: 'hidden' }}>
						{/* <BroadcastInitProvider>
						</BroadcastInitProvider> */}
						<Switch>
								<Route path={ROUTES.MANAGER} component={Manager} />
								<Redirect from="/manager/dashboard" to={ROUTES.HOMEPAGE} />
								<Redirect from="/" to={ROUTES.HOMEPAGE} />
							</Switch>
					</main>
				</div>
			</DocumentProvider>
		</div>
	);

	return <PreloadComp>{renderLayout}</PreloadComp>;
}
